import { Id, Identifiable, Kanban, Project, Status } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type ResponseStatus = {
  uuid: Id;
  name: string;
  color: string | null;
  percentComplete: number | null;
  keyRank: number;
};

type Response = {
  columns: {
    status: ResponseStatus;
    tasks: any[];
  }[];
};

function isBasic(label: string): boolean {
  return label.slice(0, "pr_".length) === "pr_";
}

function toStatus(status: ResponseStatus): Identifiable<Status> {
  return {
    uuid: status.uuid,
    label: status.name,
    color: status.color || "",
    percentComplete: status.percentComplete ?? undefined,
    basic: isBasic(status.name),
    keyRank: status.keyRank,
  };
}

function getKanban(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${uuid}/kanban`,
        method: HttpMethods.GET,
      })
      .then(({ columns }) =>
        columns.map((column) => {
          const status = toStatus(column.status);

          return {
            status,
            tasks: column.tasks.map((task) => ({
              ...task,
              status,
              tags: (task.tags || []).map((tag: any) =>
                typeof tag === "string" ? { name: tag } : { name: tag.name },
              ),
            })),
          };
        }),
      )
      // @ts-ignore
      .then((columns) => ({ columns }) as Kanban);
}

export { getKanban };
